import {
  AfterViewInit,
  Component,
  ElementRef,
  OnDestroy,
  ViewChild,
  ViewEncapsulation,
} from "@angular/core";
import { Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { NgMarqueeComponent } from "ng-marquee";
import { fromEvent, Observable, Subscription } from "rxjs/index";
import {
  debounceTime,
  delay,
  distinctUntilChanged,
  filter,
  map,
  takeWhile,
} from "rxjs/operators";
import { AuthenticationSelectors } from "../../../auth/state/authentication.selectors";
import { SystemSettingsActions } from "../../../core/state/system-settings.actions";
import { SystemSettingsSelectors } from "../../../core/state/system-settings.selectors";
import { GaContentTypeEnum } from "../../../analytics/enums/ga-content-tpye.enum";
import { GaActionEnum } from "../../../analytics/enums/ga-action.enum";
import { GoogleAnalyticsService } from "../../../analytics/service/google-analytics.service";

@Component({
  selector: "app-news-widget",
  templateUrl: "./news-widget.component.html",
  styleUrls: ["./news-widget.component.css"],
  encapsulation: ViewEncapsulation.None,
})
export class NewsWidgetComponent implements AfterViewInit, OnDestroy {
  private subscription: Subscription = new Subscription();
  public currentUser$: Observable<any>;
  systemSettings$: Observable<any>;
  public animationDuration$: Observable<any>;

  @ViewChild("dashboardNewsWidget") dashboardNewsWidget: ElementRef;

  @ViewChild("ngMarquee") ngMarquee: NgMarqueeComponent;

  active = true;

  constructor(
    private store: Store<any>,
    private systemSettingsSelectors: SystemSettingsSelectors,
    private authenticationSelectors: AuthenticationSelectors,
    private googleAnalyticsService: GoogleAnalyticsService,
    private router: Router
  ) {
    // Setup state selectors

    this.systemSettings$ = systemSettingsSelectors.selectSystemSettings().pipe(
      filter((systemSettings) => systemSettings !== undefined),
      map((systemSettings) => systemSettings.settings)
    );

    this.currentUser$ = this.authenticationSelectors.selectCurrentUser();
  }

  ngAfterViewInit(): void {
    const subscription = this.currentUser$.subscribe((user) => {
      this.store.dispatch(SystemSettingsActions.getSystemSettings());
    });

    // TODO: Merge with stream of element width change (and window resize)
    this.animationDuration$ = this.systemSettings$.pipe(
      delay(1), // Trick to let ng-marquee calculate width of scrolling div - which includes text and space to the left to let the text start outside of the wrapper
      map((settings) =>
        this.ngMarquee !== undefined
          ? (this.ngMarquee.animationElem.nativeElement.offsetWidth * 2) /
            this.dashboardNewsWidget.nativeElement.offsetWidth
          : 4000
      )
    );

    // Since ng-marquee does not (yet) support dynamic update of "duration" we need to update the internal style by subscription
    this.subscription.add(
      this.animationDuration$.subscribe((duration) => {
        console.log("duration", duration);
        if (this.ngMarquee !== undefined) {
          this.ngMarquee.animationElem.nativeElement.style.animationDuration = `${duration}s`;
        }
      })
    );

    this.subscription.add(subscription);

    fromEvent(this.dashboardNewsWidget.nativeElement, "click").subscribe(
      (event) => {
        /**
         * GOOGLE ANALYTICS
         */
        const gaEventParam = new Map<string, any>([
          ["content_type", GaContentTypeEnum.CLICK_INSPIRE],
        ]);
        this.googleAnalyticsService.event(
          GaActionEnum.SELECT_CONTENT,
          gaEventParam
        );
      }
    );
  }

  setRoute($event): void {
    this.router.navigate(["inspire"]);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
